import React from "react";
import NiceModal from "@ebay/nice-modal-react";
import { useHistory } from "react-router-dom";
import { DASHBOARD } from "src/utils/constants/routes";

/**
 * A route that opens a dialog and hands the reader back to the dashboard.
 *
 * `/deposit` and `/withdraw` are linked from elsewhere in the product and may
 * be bookmarked, so they cannot simply stop working now that the sidebar
 * opens these flows in place. Arriving by URL lands on the dashboard with the
 * dialog already open over it — which is the same state the sidebar produces,
 * so there is one behaviour rather than two.
 */
const OpenOnRoute: React.FC<{ modal: string }> = ({ modal }) => {
  const history = useHistory();

  React.useEffect(() => {
    /* Navigate FIRST, then open. Rendering a <Redirect> instead unmounted
       this route in the same commit as the show, and the dialog came up
       against a page that was already on its way out — it appeared and then
       faded straight back down. Replacing rather than pushing also means Back
       goes wherever the reader came from, not to a route that only ever
       redirects. */
    history.replace(DASHBOARD);
    NiceModal.show(modal);
  }, [history, modal]);

  return null;
};

export default OpenOnRoute;
